import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client.service';
import { OrderService } from 'src/app/services/order.service';
import { SystemService } from 'src/app/services/system.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-transfer-between-users',
  templateUrl: './transfer-between-users.page.html',
  styleUrls: ['./transfer-between-users.page.scss'],
})
export class TransferBetweenUsersPage implements OnInit {
  form: FormGroup;
  valueBalanceReal = 0.00;
  valueBalanceBs = 0.00;
  valueBalanceDolar = 0.00;
  fee = 0.00;
  bond = null;
  amount;

  constructor(private fb: FormBuilder, private toastCtrl: ToastController, private loadingCtrl: LoadingController,
                    private systemSerevice: SystemService, private clientService: ClientService,
                    private orderService: OrderService, private navCtrl: NavController) {
    this.form = this.fb.group({
      bondCoin: [''],
      value: ['', Validators.compose([
        Validators.required,
      ])],
      document: ['', Validators.compose([
        Validators.required,
      ])],
    });
  }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.bond = Security.getCoin();

    this.systemSerevice.getFeeTransferBetweenUsers().subscribe(result => {
      this.fee = result.data;
    });

    this.getBalanceReal();
    this.getBalanceDolar();
    this.getBalanceBs();

    loading.dismiss();
  }

  checkValue(event){
    // Remove caracteres não numéricos, exceto ponto decimal
    const numericValue = parseFloat(event.replace(/[^\d.,-]/g, '').replace(',', '.'));
    this.amount = numericValue;
    this.form.patchValue({
      value: this.amount,
    });
  }

  async transfer() {
    const loading = await this.loadingCtrl.create({ message: 'Processando...' });
    loading.present();

    let coin = 0;

    if (this.bond === '1') {
      coin = 1;
    }

    if (this.bond === '2') {
      coin = 2;
    }

    if (this.bond === '3') {
      coin = 3;
    }


    this.form.patchValue({
      bondCoin: coin
    });

    if (this.calcBalance(this.form.get('value').value)) {
      this.orderService.transferBetweenUsers(this.form.value).subscribe(result => {
        if (result.success) {
          this.showMessage(result.message);
          loading.dismiss();
          this.goToPage('/master');
        } else {
          this.showMessage(result.message);
          loading.dismiss();
        }
      }, error => {
        this.showMessage(error.message);
        loading.dismiss();
      });
    }else {
      this.showMessage('Opz... Parece que não ha saldo suficiente!');
      loading.dismiss();
    }
  }

  calcBalance(value): boolean {
    if (this.bond === '1'){
      if (this.valueBalanceReal >= value) {
        return true;
      } else {
        return false;
      }
    }
    if (this.bond === '2') {
      if (this.valueBalanceBs >= value) {
        return true;
      } else {
        return false;
      }
    }
    if (this.bond === '3') {
      if (this.valueBalanceDolar >= value) {
        return true;
      } else {
        return false;
      }
    }
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen,  duration: 3000 });
    error.present();
  }

  async getBalanceReal() {
    this.clientService.getBalanceReal().subscribe(result => {
      this.valueBalanceReal = result.data;
    });
  }

  async getBalanceBs() {
    this.clientService.getBalanceBs().subscribe(result => {
      this.valueBalanceBs = result.data;
    });
  }

  async getBalanceDolar() {
    this.clientService.getBalanceDolar().subscribe(result => {
      this.valueBalanceDolar = result.data;
    });
  }

  goToPage(page: string) {
    this.navCtrl.navigateForward(page);
  }

}
